import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ContactSec.module.css";
import { FaPhone, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { trackWhatsAppClick } from "../../../utils/analytics";
import { getOnboardingUrl } from "../../../utils/portalUrl";

const PHONE_DISPLAY = "+972 053-3920842";
const PHONE_TEL = "tel:+972533920842";
const WHATSAPP_URL = "https://wa.me/972533920842";
const SUPPORT_EMAIL = "hello@stylon.co";

const ContactSec = () => {
  const { t } = useTranslation();

  return (
    <div className={`container ${styles.parent}`} id="contact">
      <div className={styles.contactCard}>
        <div className={styles.contactBadge}>{t("contact.badge")}</div>
        <h2 className={styles.contactHeading}>{t("contact.heading")}</h2>
        <p className={styles.contactSubtitle}>{t("contact.subtitle")}</p>

        <div className={styles.contactInfoRow} dir="ltr">
          <FaPhone className={styles.contactInfoIcon} />
          <a href={PHONE_TEL} className={styles.contactInfoText}>{PHONE_DISPLAY}</a>
        </div>
        <div className={styles.contactInfoRow} dir="ltr">
          <FaEnvelope className={styles.contactInfoIcon} />
          <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.contactInfoText}>{SUPPORT_EMAIL}</a>
        </div>

        <div className={styles.divider} />

        <div className={styles.contactActions}>
          <a href={`mailto:${SUPPORT_EMAIL}`} className={`${styles.contactBtn} ${styles.emailBtn}`}>
            <FaEnvelope className={styles.contactBtnIcon} /> {t("contact.email")}
          </a>
          <a href={PHONE_TEL} className={`${styles.contactBtn} ${styles.callBtn}`}>
            <FaPhone className={styles.contactBtnIcon} /> {t("contact.call")}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.contactBtn} ${styles.whatsappBtn}`}
            onClick={() => trackWhatsAppClick("contact")}
          >
            <FaWhatsapp className={styles.contactBtnIcon} /> {t("contact.whatsapp")}
          </a>
        </div>

        <div className={styles.ctaWrap}>
          <a
            href={getOnboardingUrl("contact")}
            className={`${styles.contactBtn} ${styles.callBtn}`}
            style={{ width: "100%", maxWidth: 320, margin: "0 auto" }}
          >
            {t("nav.startNow")} →
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactSec;
